/* LUCRÜ™ — © 2026 LUCRÜ. All rights reserved. */
import { ChartLineUpIcon, UsersThreeIcon, SpeakerHighIcon } from "@phosphor-icons/react";

const StatsPanel = ({ stats }) => {
  const top = stats?.top_chatters || [];
  return (
    <div className="glass rounded-2xl p-5 flex-1">
      <div className="flex items-center justify-between mb-4">
        <div className="font-display font-black text-sm uppercase tracking-widest">Stats</div>
        <ChartLineUpIcon size={16} color="#39FF14" />
      </div>

      <div className="grid grid-cols-2 gap-2 mb-5">
        <div className="bg-[#0F0F16] border border-[#222233] rounded-lg p-3">
          <div className="text-[10px] uppercase tracking-wider text-white/40 flex items-center gap-1">
            <SpeakerHighIcon size={10} /> Read
          </div>
          <div className="font-display font-black text-2xl mt-1 text-[#00E5FF]" data-testid="stat-read">
            {stats?.messages_read || 0}
          </div>
        </div>
        <div className="bg-[#0F0F16] border border-[#222233] rounded-lg p-3">
          <div className="text-[10px] uppercase tracking-wider text-white/40 flex items-center gap-1">
            <ChartLineUpIcon size={10} /> Total
          </div>
          <div className="font-display font-black text-2xl mt-1 text-white" data-testid="stat-total">
            {stats?.total_messages || 0}
          </div>
        </div>
      </div>

      <div className="text-[10px] uppercase tracking-wider text-white/40 mb-2 flex items-center gap-1">
        <UsersThreeIcon size={10} /> Top chatters
      </div>
      <div className="space-y-1.5" data-testid="top-chatters">
        {top.length === 0 && (
          <div className="text-xs text-white/30">No chatters yet…</div>
        )}
        {top.map((t, i) => (
          <div key={t.username} className="flex items-center gap-2 text-xs">
            <span className="w-4 text-white/40 font-mono">#{i + 1}</span>
            <span className="flex-1 truncate">{t.username}</span>
            <span className="text-[#39FF14] font-semibold">{t.count}</span>
          </div>
        ))}
      </div>
    </div>
  );
};

export default StatsPanel;
